export default "__VITE_ASSET__arO7fzav__"